import {DataGridPro, GridFilterModel, GridSortModel, useGridApiRef} from "@mui/x-data-grid-pro";
import {ChangeEvent, useEffect, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {Input, Select, Spin} from 'antd';
import GridPagination from "../GridPagination/GridPagination";
import Header from "../Header/Header";
import s from './Districts.module.scss'
import {deDELocaleText} from '../../utils/dataGridLocale.de';
import {LoadingOutlined} from "@ant-design/icons";
import { normalizeGerman, stemGermanWord } from "../../helpers/funcHelper";
import {
    GetDistrictsList,
    selectDistrictsGridRows,
    selectDefaultDistrictsGridRows,
    selectCurrentPage,
    selectIsDistrictsLoading,
    onSetCurrentPage,
    onSetGridRows,
    selectOrganizationOptions
} from "../../store/districtsReducer";
import { DistrictType } from "../../types/districtsTypes";
import { useNavigate } from "react-router-dom";

const Districts = () => {
    const apiRef = useGridApiRef()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const gridRows = useAppSelector(selectDistrictsGridRows)
    const defaultGridRows = useAppSelector(selectDefaultDistrictsGridRows)
    const page = useAppSelector(selectCurrentPage)
    const organizationOptions = useAppSelector(selectOrganizationOptions)

    const [searchTerm, setSearchTerm] = useState('')
    const [selectedOrganization, setSelectedOrganization] = useState(0)
    const [filterModel, setFilterModel] = useState<GridFilterModel>({items: []});
    const [sortModel, setSortModel] = useState<GridSortModel>([]);
    const isDataLoading = useAppSelector(selectIsDistrictsLoading)

    useEffect(() => {
        dispatch(GetDistrictsList())
    }, [dispatch])

    // const onDeleteDistrict = (id: number) => {
    //     dispatch(DeleteDistrict(id))
    // }

    const columns = [
        {
            field: 'name',
            headerName: 'Titel',
            flex: 1,
            minWidth: 150,
        },
        {
            field: 'description',
            headerName: 'Beschreibung',
            flex: 1.5,
            minWidth: 200,
        },
        {
            field: 'organization',
            headerName: 'Organization',
            flex: 0.5,
            minWidth: 100,
            valueGetter: (_: any, district: DistrictType) => {
                return district?.organization?.name
            },
        },
        {
            field: 'latitude',
            headerName: 'Breitengrad',
            flex: 0.7,
            minWidth: 100,
        },
        {
            field: 'longitude',
            headerName: 'Längengrad',
            flex: 0.7,
            minWidth: 100,
        },
        {
            field: 'address',
            headerName: 'Adresse',
            flex: 1.5,
            minWidth: 200,
        },
        {
            field: 'url',
            headerName: 'URL',
            flex: 1,
            minWidth: 150,
            renderCell: (params: { row: DistrictType }) => (
                params.row.url ? (
                    <a href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: '#1F553B' }}>
                        {params.row.url}
                    </a>
                ) : '-'
            ),
        },
        {
            field: '_',
            headerName: '',
            flex: 0.3,
            minWidth: 60,
            sortable: false,
            filterable: false,
            pinned: 'right',
            renderCell: (data: any) => (
                <div style={{
                    marginTop: '4px'
                }}>
                    {/* <Popconfirm
                        title="Diese Anfrage löschen?"
                        description="Diese Aktion kann nicht rückgängig gemacht werden."
                        onConfirm={() => onDeleteDistrict(data.row.id)}
                        okText="Ja"
                        cancelText="Nein"
                        okType="danger"
                    >
                        <button className={s.actionBtn}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                 fill="none">
                                <path
                                    d="M2.5 4.99996H4.16667M4.16667 4.99996H17.5M4.16667 4.99996V16.6666C4.16667 17.1087 4.34226 17.5326 4.65482 17.8451C4.96738 18.1577 5.39131 18.3333 5.83333 18.3333H14.1667C14.6087 18.3333 15.0326 18.1577 15.3452 17.8451C15.6577 17.5326 15.8333 17.1087 15.8333 16.6666V4.99996H4.16667ZM6.66667 4.99996V3.33329C6.66667 2.89127 6.84226 2.46734 7.15482 2.15478C7.46738 1.84222 7.89131 1.66663 8.33333 1.66663H11.6667C12.1087 1.66663 12.5326 1.84222 12.8452 2.15478C13.1577 2.46734 13.3333 2.89127 13.3333 3.33329V4.99996M8.33333 9.16663V14.1666M11.6667 9.16663V14.1666"
                                    stroke="#667085" strokeWidth="1.66667" strokeLinecap="round"
                                    strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </Popconfirm> */}
                    <button className={s.actionBtn} onClick={() => navigate(`/districts/${data.row.id}`)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_448_2126)">
                                <path
                                    d="M14.1667 2.50005C14.3856 2.28118 14.6454 2.10756 14.9314 1.98911C15.2173 1.87066 15.5238 1.80969 15.8334 1.80969C16.1429 1.80969 16.4494 1.87066 16.7353 1.98911C17.0213 2.10756 17.2812 2.28118 17.5 2.50005C17.7189 2.71892 17.8925 2.97875 18.011 3.26472C18.1294 3.55069 18.1904 3.85719 18.1904 4.16671C18.1904 4.47624 18.1294 4.78274 18.011 5.06871C17.8925 5.35468 17.7189 5.61451 17.5 5.83338L6.25002 17.0834L1.66669 18.3334L2.91669 13.75L14.1667 2.50005Z"
                                    stroke="#667085" stroke-width="1.66667" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_448_2126">
                                    <rect width="20" height="20" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                </div>
            )
        }
    ]

    const onChangeGridPage = (page: number) => {
        dispatch(onSetCurrentPage(page))
    }

    const filterBySearch = (districts: DistrictType[], search: string) => {
        if (!search?.length) return districts;
        const matchesSearch = (r: typeof defaultGridRows[number]) => {
            const stemmedValue = stemGermanWord(normalizeGerman(search.toLowerCase()));

            const fields = [
                r.name,
                r.description,
                r.organization.name,
            ];

            return fields.some(field => {
                const normalized = normalizeGerman(field?.toLowerCase() || '');
                return normalized.includes(stemmedValue);
            });
        };
        return districts.filter(matchesSearch);
    }

    const filterByOrganization = (districts: DistrictType[], organization: number) => {
        setSelectedOrganization(organization)
        if (organization === 0) return districts
        return districts.filter((district) => district.organization.id === organization)
    }

    const getCurrentGridRows = (search: string, organization: number) => {
        let rows = defaultGridRows
        const filteredByOrganization = filterByOrganization(rows, organization)
        let filteredRows = filterBySearch(filteredByOrganization, search)
        return filteredRows
    }

    const handleOrganizationChange = (value: number) => {
        onChangeGridPage(0)
        dispatch(onSetGridRows(getCurrentGridRows(searchTerm, value)))
    }


    const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchTerm(value);
        onChangeGridPage(0)
        dispatch(onSetGridRows(getCurrentGridRows(value, selectedOrganization)))
    };

    const didRestore = useRef(false);

    useEffect(() => {
        if (didRestore.current) return;

        const saved = sessionStorage.getItem("districtsGridState");
        if (saved) {
            const {filterModel, sortModel} = JSON.parse(saved);
            setFilterModel(filterModel);
            setSortModel(sortModel);
        }

        didRestore.current = true;
    }, []);

    useEffect(() => {
        if (!didRestore.current) return; // skip first run
        sessionStorage.setItem(
            "districtsGridState",
            JSON.stringify({filterModel, sortModel})
        );
    }, [filterModel, sortModel]);

    return (
        <div>
            <Header/>
            <div className={s.inner}>
                <h1 className={s.inner__title}>Liste der Bezirke</h1>
                <p className={s.inner__subtitle}>Alle Bezirke ansehen</p>
                <div className={s.searchAndFilters}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <Input
                            type="text"
                            value={searchTerm}
                            placeholder={'Suchen'}
                            onChange={handleSearchInputChange}
                            className={s.searchAndFilters__searchInput}
                            prefix={
                                <svg style={{
                                    marginRight: '8px'
                                }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                     fill="none">
                                    <path
                                        d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                                        stroke="#667085" strokeWidth="1.66667" strokeLinecap="round"
                                        strokeLinejoin="round"/>
                                </svg>
                            }
                            allowClear
                        />
                        <Select
                            value={selectedOrganization}
                            onChange={handleOrganizationChange}
                            style={{width: 180}}
                            options={organizationOptions}
                            className={'districtsSelect'}
                        />
                    </div>
                </div>
                {
                    !isDataLoading
                    ?
                        <DataGridPro
                            localeText={deDELocaleText}
                            sx={{
                                borderRadius: '8px',
                                border: '1px solid var(--Gray-200, #EAECF0)',
                                background: '#FFF)',
                                boxShadow: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
                                "& .MuiDataGrid-cellContent": {
                                    fontFamily: 'Inter, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: '#101828',
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                    fontFamily: 'Inter, sans-serif',
                                    fontWeight: 500,
                                    color: '#667085',
                                    fontSize: '12px',
                                    lineHeight: '18px',
                                },
                                "& .MuiDataGrid-cell:focus": {
                                    outline: 'none'
                                },

                            }}
                            apiRef={apiRef}
                            getRowId={(row) => row.id}
                            rows={gridRows}
                            {...gridRows}
                            hideFooterSelectedRowCount
                            sortingOrder={['desc', 'asc']}
                            rowHeight={72}
                            columnHeaderHeight={44}
                            columns={columns}
                            pagination
                            filterModel={filterModel}
                            onFilterModelChange={(newModel) => {
                                onChangeGridPage(0);
                                setFilterModel(newModel);
                            }}
                            sortModel={sortModel}
                            onSortModelChange={(newModel) => {
                                onChangeGridPage(0);
                                setSortModel(newModel);
                            }}
                            slots={{pagination: GridPagination}}
                            paginationModel={{pageSize: 10, page}}
                            onPaginationModelChange={(model) => {
                                onChangeGridPage(model.page);
                            }}
                            pageSizeOptions={[10, 25, 50]}
                            initialState={{
                                pinnedColumns: {
                                    right: ['_'],
                                },
                                sorting: {
                                    sortModel: [{field: 'date_created', sort: 'desc'}],
                                },
                            }}
                        />
                        :
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '65vh',
                            flexDirection: 'column'
                        }}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#1F553B' }} spin />} />
                        </div>
                }
            </div>
        </div>
    );
};

export default Districts;
